import util, { getCurrency } from "../Utils/utils";
import { dateFnsMoment as moment } from "../Utils/DateFnsMoment";
import axios from "axios";
import { getQueryData } from "../Helper/helper";
import { notification } from "../Shared/NotificationModal";

export default class FlightService {
  searchFlight(body) {
    const queryData = getQueryData(window.location.search);
    const cabin = queryData && queryData.cabin ? Number(queryData.cabin) : 4;
    const utmCampaign =
      queryData && queryData.utm_campaign
        ? queryData.utm_campaign
        : "localSearch";
    let params = { ...body };
    params.arrival = params.arrival
      ? moment(params.arrival).format("YYYY-MM-DD")
      : "";
    params.depart = moment(params.depart).format("YYYY-MM-DD");
    params.to = params.to;
    params.from = params.from;
    params.cabin = cabin;
    params.utm_campaign = utmCampaign;
    params.currency = getCurrency();
    return util
      .sendApiRequest("/flight/search", "POST", true, params)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }

  //get flight offers
  searchFlightOffers(body) {
    let params = { ...body };
    params.arrival = params.arrival
      ? moment(params.arrival).format("YYYY-MM-DD")
      : "";
    params.depart = moment(params.depart).format("YYYY-MM-DD");
    params.to = params.to;
    params.from = params.from;
    // return util
    //   .sendApiRequest("/flight/search/offers", "POST", true, params)
    //   .then((response) => {
    //     return response;
    return new Promise(async (resolve, reject) => {})
      .then(() => {
        return null;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }

  getAirLineCode(body) {
    return util
      .sendApiRequest("/flight/airlinecode", "POST", true, body)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }

  getActualUrl(body) {
    return util
      .sendApiRequest("/url/get-actual-url", "POST", true, body)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }

  getAirportCode(airportCodeQuery) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `https://autocomplete.travelpayouts.com/jravia?locale=en&with_countries=false&q=${airportCodeQuery}`,
        )
        .then((response) => {
          // If jravia returns status 202 → call places2
          if (response.data.status && response.data.status === 202) {
            this.getAirportCodeFromPlaces(airportCodeQuery)
              .then((placesData) => resolve(placesData))
              .catch((err) => reject(err));
          } else {
            resolve(response.data);
          }
        })
        .catch((err) => {
          notification(
            "error",
            "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
          );
          reject(err);
        });
    });
  }

  getAirportCodeFromPlaces(airportCodeQuery) {
    return axios
      .get(
        `https://autocomplete.travelpayouts.com/places2?locale=en&types[]=airport&types[]=city&term=${airportCodeQuery}`,
      )
      .then((response) => {
        const updatedData = response.data.map((item) => ({
          ...item,
          city_name: item.city_name ?? item.name,
        }));
        return updatedData;
      });
  }
  ListgetAirportCode(list) {
    return util
      .sendApiRequest("/flight/airportcode/", "POST", true, list)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }

  getGoogleFlightDetails(data) {
    return util
      .sendApiRequest("/flight/get-google-adv-result", "POST", true, data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
        // notification(
        //   "error",
        //   "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!"
        // );
      });
  }

  getFlightDetails(data) {
    return util
      .sendApiRequest("/flight/get-flight-details", "POST", true, data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }

  bookFlight(data) {
    return util
      .sendApiRequest("/flight/make-agent-booking", "POST", true, data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }

  payment(order) {
    return util
      .sendApiRequest("/flight/payment/", "POST", true, order)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }

  bookingPayment(data) {
    return util
      .sendApiRequest("/payment/booking-payment", "POST", true, data)
      .then((response) => {
        if (response && response.success === false) {
          throw response;
        }

        return response;
      })
      .catch((err) => {
        let responseData = err;

        if (typeof err === "string") {
          try {
            responseData = JSON.parse(err);
          } catch {
            responseData = err;
          }
        }

        notification(
          "error",
          responseData?.message ||
            responseData?.error ||
            "Payment could not be completed. Please try again.",
        );

        throw new Error(
          responseData?.message ||
            responseData?.error ||
            "Payment request failed.",
        );
      });
  }

  completeBooking(data) {
    return util
      .sendApiRequest("/flight/complete-booking", "POST", true, data)
      .then((response) => {
        if (response && response.success === false) {
          throw response;
        }

        return response;
      })
      .catch((err) => {
        let responseData = err;

        if (typeof err === "string") {
          try {
            responseData = JSON.parse(err);
          } catch {
            responseData = err;
          }
        }

        throw new Error(
          responseData?.message ||
            responseData?.error ||
            "Booking could not be completed.",
        );
      });
  }

  bookingHistory() {
    return util
      .sendApiRequest("/flight/bookinghistory/", "GET", true)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }
  bookingHistoryDetail(id) {
    return util
      .sendApiRequest("/flight/bookinghistorydetail/" + id, "GET", true)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }

  getFlightAirRule(body) {
    return util
      .sendApiRequest("/flight/get-rules/", "POST", true, body)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }

  getCampaignDetails(utm_campaign) {
    return util
      .sendApiRequest("/campaign/" + utm_campaign, "GET", true)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        notification(
          "error",
          "Oops something went wrong at our end and we know this is embarrassing. We are working on it, please try again later!",
        );
      });
  }
}
